export function getIdFromName(object, value) {
  const values = Object.values(object);
  const keys = Object.keys(object);
  const index = values.indexOf(value);
  return index !== -1 ? keys[index] : null;
}

export function deigrengCase(name) {
  if (name === "déi gréng") {
    return "déi Gréng";
  } else {
    return name;
  }
}

export function getSeatNumber(lists) {
  let seats = [];
  lists.forEach((list) => {
    let seat = {
      party: list.sigles[0].sigle.contenu,
      seats: parseInt(list.mandatsAttribues),
    };
    seats.push(seat);
  });
  return seats;
}

export function formatNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function imageNameFormat(firstname, lastname, newJsonArray, commune) {
  // check if the candidate's first name and last name already exist in the newJsonArray
  if (lastname.indexOf(" ") > -1) {
    return (
      formatString(firstname) +
      "_" +
      formatString(lastname.split(" ")[0]) +
      "_" +
      formatString(lastname.split(" ")[1])
    );
  }

  return (formatString(firstname) + "_" + formatString(lastname)).toLowerCase();
}

export function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // JS months are 0-based
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}.${month}.${year} ${hours}:${minutes}`;
}

// Convert excel date to javascript date
export function excelDateToJSDate(serial) {
  if (serial) {
    var date = new Date((serial - 25569) * 86400000);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return day + "." + month + "." + year;
  }
  return "";
}

// format string. remove accents, replace spaces with dashes and lowercase
export function formatString(string) {
  if (string) {
    return string
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "");
  }
  return "";
}
// to title case function for strings (first letter of each word is capitalized)
export function capitalizeWords(string) {
  return string.toLowerCase().replace(/(?:^|\s|[-'’])(\S)/gu, function (match) {
    return match.toUpperCase();
  });
}
